module.exports = __webpack_public_path__ + "img/slide-6.1bdb7066.jpeg";